/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { StackView } from '@veeam/components';
import styled from 'styled-components';

import { StyledToggleButton } from './ToggleButton.styled';

export const StyledToggleButtons = styled(StackView)`
    ${StyledToggleButton}:not(:first-child) {
        margin-left: -1px;
    }
`;
